import React from 'react';
import { Document } from '@contentful/rich-text-types';
import { RichText } from '../../richText';

interface CaseStudyCentralContentProps {
  content: Document;
}

interface StatItem {
  content: string;
}

export const CaseStudyCentralContent: React.FC<CaseStudyCentralContentProps> = ({
  content,
}) => {
  return (
    <div className="relative w-full py-32 border-t border-b border-black cs-bordered">
      <span className="absolute top-0 left-0 w-1/2 h-full border-r border-black" />

      <div className="relative w-3/4 p-8 mx-auto border border-black md:p-24 md:pb-16 md:max-w-3xl bg-neutral">
        <RichText content={content} />
      </div>

    </div>
  );
};
